import React from 'react';
import {Link} from 'react-router-dom';
import {Button} from '@mui/material';
import {FullPageContainer} from 'components/common/Containers';
import ErrorMessage from 'components/common/ErrorMessage';

export default function NotFound() {
    return (
      <FullPageContainer absolute>
        <ErrorMessage title='404' subtitle="We don't have such page. Where did you get it?">
          <Button component={Link} variant='contained' to='/'>Back to home</Button>
          <Button component={Link} to='/login'>Back to login</Button>
        </ErrorMessage>
      </FullPageContainer>
    );
}
